import React, { useMemo, useState, useEffect } from "react"
import { FaEdit, FaEye } from "react-icons/fa"
import { useSelector, useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import TableContainer from "../../../components/Common/DataTableContainer"
import { fetchEvents } from "../../../redux/actions/event"
import ActionDropdown from "components/ActionDropdown"
import { Button } from "reactstrap"

const PastList = () => {
  document.title = "Past Event List | PULA"

  const dispatch = useDispatch()
  const history = useNavigate()

  const eventsState = useSelector(state => state.event)

  const [eventsData, setEventsData] = useState([])

  console.log("eventsData", eventsData)

  const columns = useMemo(
    () => [
      {
        header: "Event Name",
        accessorKey: "title",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Date",
        accessorKey: "event_date",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Time",
        accessorKey: "time",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Total Seats",
        accessorKey: "total_seats",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Available Seats",
        accessorKey: "available_seats",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Status",
        accessorKey: "status",
        enableColumnFilter: false,
        enableSorting: true,
        cell: info => (info.getValue() === 1 ? "Active" : "Inactive"),
      },
      {
        header: "Action",
        accessorKey: "action",
        enableColumnFilter: false,
        enableSorting: false,
        cell: info => {
          const row = info.row.original
          return (
            <ActionDropdown buttonLabel="Edit & View">
              <button
                className="dropdown-item"
                onClick={() => history(`/events/edit-event/${row.url}`)}
                title="Edit Event"
              >
                <span>Edit Event</span>
                <FaEdit />
              </button>
              <button
                className="dropdown-item btn btn-sm btn-info"
                onClick={() => history(`/events/view-event/${row.url}`)}
                title="View Event"
              >
                <span>View Bookings</span>
                <FaEye />
              </button>
            </ActionDropdown>
          )
        },
      },
    ],
    []
  )

  useEffect(() => {
    dispatch(fetchEvents({ filter: "all-past" }))
  }, [dispatch])

  useEffect(() => {
    if (eventsState && Array.isArray(eventsState.allPastEventList)) {
      setEventsData(eventsState.allPastEventList)
    }
  }, [eventsState])

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="mb-3 pb-2"></div>
        <div className="d-flex align-items-center justify-content-between mb-4">
          <h2 className="nom-title mb-0">Past Event List</h2>
          <Button
            color="primary"
            onClick={() => (window.location.href = "/events/add-event")}
          >
            Add Event
          </Button>
        </div>
        <TableContainer
          defaultPageSize={20}
          columns={columns}
          data={eventsData || []}
          isGlobalFilter={true}
          isPagination={true}
          isCustomPageSize={true}
          SearchPlaceholder="Search records..."
          pagination="pagination"
          paginationWrapper="dataTables_paginate paging_simple_numbers"
          tableClass="table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
          theadClass="table-light"
          divClassName="table-responsive mb-4"
        />
      </div>
    </div>
  )
}

export default PastList
